import { option, record } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { parentSelector } from '../../selectors/parentSelector';

const getReservationGroupsData = createSelector(parentSelector, (state) => state.entities.reservationGroups.data);
const getReservationGroup = createSelector(
    getStringProp('reservationGroupId'),
    getReservationGroupsData,
    (reservationGroupId, reservationGroupsData) => pipe(reservationGroupsData, record.lookup(reservationGroupId))
);

export const getReservationGroupName = createSelector(
    getReservationGroup,
    flow(
        option.map((reservationGroup) => reservationGroup.name),
        option.toNullable
    )
);
